import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { LanguageSchema, Language } from '@authy/lib-common/entities'
import { locale as common, mergeResources } from '@authy/lib-common/i18n'
import { locale as client } from '@authy/lib-client/i18n'

import { locale } from './locale'

const resources = mergeResources(locale, [common, client])

i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
})

declare module 'i18next' {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface CustomTypeOptions {
        defaultNS: 'en'
        resources: {
            en: typeof resources.en.translation
        }
    }
}

export const normalizeLanguage = (language: string | null | undefined): Language => {
    if (LanguageSchema.safeParse(language).success) {
        return language as Language
    }

    return 'en'
}

export const getBrowserLanguage = (): Language => {
    return normalizeLanguage(window.navigator.language.split('-')[0])
}
